import { inject, injectable } from "@launchtray/tsyringe-async";
import { PieceColor } from "../../../enums/PieceColor";
import { TriangleRotationStatus } from "../../../enums/TriangleRotationStatus";
import { ISquareModel } from "../../../models/square/ISquareModel";
import { ITriangleModelFactory } from "../../triangles/ITriangleModelFactory";
import { ISquareModelFactory } from "../ISquareModelFactory";
import { SquareModel } from "../../../models/square/impl/SquareModel";
import { InjectableModelFactories } from "../../../../../composition/InjectableModelFactories";

@injectable()
export class HalfSquareModelFactory implements ISquareModelFactory {
    public constructor(
        @inject(InjectableModelFactories.ITriangleModelFactory) private readonly triangleModelFactory: ITriangleModelFactory
    ) { }

    public createSquare(rotationStatus: TriangleRotationStatus, color: PieceColor): ISquareModel {
        return new SquareModel([this.triangleModelFactory.createTriangle(rotationStatus, color)]);
    }
}